// ReduxUser.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  EMPIMAGE: null,
  EMPNAME: null,
  MESSAGE:null,
  RESTNAME: null,
  STAFFID: null,
  STAFFMAPLOCODE: null,
  SYSDATE: null,
  LOCTIMEZONE: null,
  USERREFCODE: null,
  COMPCODE: null,
    LOCCODE: null,
  CSCODE: null,
  COMPNAME: null,
  LOGSTST: null,
  COMPANYLOGO: null,
  STYPE: null,
  STOREDATE: null,
  DASHBOARDSTYLE: null,
  USERNAME: null,
  GROUPNAME: null,
  GROUPCODE: null,
  TEMPKEY: null,
  TOKEN: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserParams: (state, action) => {
      console.log("Payload received:", action.payload);
      state.USER_PARAM = { ...action.payload };
      const randomLogo = "src/assets/images/shield2.png";
      state.COMPANYLOGO = action.payload.COMPANYLOGO || randomLogo;
      state.USERREFCODE = action.payload.USERREFCODE;
      state.TEMPKEY = action.payload.TEMPKEY || "";
    },
    resetUserParams: () => initialState,
    // setCodes: (state, action) => {
    //   const { COMPCODE,   LOCCODE:STAFFMAPLOCODE,, RESTCODE } = action.payload;
    //   state.COMPCODE = COMPCODE;
    //   state.  LOCCODE:STAFFMAPLOCODE, =   LOCCODE:STAFFMAPLOCODE,;
    //   state.RESTCODE = RESTCODE;
    // },
  },
});

export const { setUserParams, resetUserParams } = userSlice.actions;

export default userSlice.reducer;
